import { DataModelBuilder, isSameData, isSameList, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LocalizedString } from '../../models/serializable/localized-string.js';
import { ProfilePageLink } from '../../models/serializable/profile-page-link.js';
import { MapUtils } from '../../utility/map-utils.js';
import { RenderableComponent } from '../core/component.js';

export class ProfilePageListComponent extends RenderableComponent {
  static readonly TYPE_ID: string = '81659b53e3d34f2a943f76735f2e1bcc';
  static readonly DEFAULT_RENDER_ORDER: number = 16;

  constructor(
    public readonly titles: LocalizedString,
    public readonly descriptions: LocalizedString,
    public readonly links: ProfilePageLink[],
    public readonly renderOrder: number,
    public readonly isRenderingEnabled: boolean,
  ) {
    super();
  }

  get $typeId() {
    return ProfilePageListComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ProfilePageListComponent {
    return new ProfilePageListComponent(
        context.fromData<LocalizedString>(MapUtils.get<SerializedData>(map, 'titles')),
        context.fromData<LocalizedString>(MapUtils.get<SerializedData>(map, 'descriptions')),
        MapUtils.getList<ProfilePageLink>(
            map,
            'links',
            (value) => context.fromData<ProfilePageLink>(value as SerializedData)
        ),
        MapUtils.get<number>(map, 'renderOrder'),
        MapUtils.get<boolean>(map, 'isRenderingEnabled'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'titles': context.toData(this.titles),
      'descriptions': context.toData(this.descriptions),
      'links': this.links.map((e) => context.toData(e)),
      'renderOrder': this.renderOrder,
      'isRenderingEnabled': this.isRenderingEnabled,
    };
  }

  clone(): this {
    return new ProfilePageListComponent(
        this.titles.clone(),
        this.descriptions.clone(),
        this.links.map((e) => e.clone()),
        this.renderOrder,
        this.isRenderingEnabled,
    ) as this;
  }

  isSame(other: ProfilePageListComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.titles, this.titles) &&
      isSameData(other.descriptions, this.descriptions) &&
      isSameList(other.links, this.links) &&
      other.renderOrder === this.renderOrder &&
      other.isRenderingEnabled === this.isRenderingEnabled;
  }
}

export class ProfilePageListComponentBuilder extends DataModelBuilder<ProfilePageListComponent> {
  build(context: SerializationContext, map: SerializedData): ProfilePageListComponent {
    return ProfilePageListComponent.fromMap(context, map);
  }
}
